module.exports = __webpack_public_path__ + "static/img/greenegg.12d160d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/greenegg.png
// module id = sKxZ
// module chunks = 1